import { ReactNode } from "react";
import TimelinePlayerContext from "./context/TimelinePlayerContext";
import useTimelinePlayerContextStates from "./hooks/useTimelinePlayerContextStates";

/** Owns TimelinePlayer context state + provider for host screens. */
export default function TimelinePlayerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const contextValues = useTimelinePlayerContextStates();
  return (
    <TimelinePlayerContext.Provider value={contextValues}>
      {children}
    </TimelinePlayerContext.Provider>
  );
}
